<template>
  <CompanyObjectRefSelect
    v-model="vModel"
    :options="options"
    :mode="mode"
    :default-option="noTimeBreakdownOption"
    object-type="company_dimension"
    placeholder="Time Dimension"
    external-path="/definitions"
    :external-query="{
      tab: 'dimensions',
    }" />
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import CompanyObjectRefSelect from '@/components/reports/config/common/CompanyObjectRefSelect'

  export default {
    name: 'TrackerTableTimeDimension',
    components: {
      CompanyObjectRefSelect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
    computed: {
      noTimeBreakdownOption () {
        // Clearing the time dimension drops the period columns entirely and
        // leaves a table of measures against total columns.
        return { name: 'No time breakdown (totals only)', }
      },
      options () {
        var options = { ...this.companyDimensionOptions, }
        Object.keys(options).forEach(key => {
          if (options[key].dimension?.type != 'ExpressionTimeDimension') {
            delete options[key]
          }
        })
        return options
      },
    },
  }
</script>

<style lang="scss" scoped></style>
